/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TimeDuration {
    getFixupPrototypeFunction() { return TimeDuration.fixupPrototype; }

    static newInstance(model: Partial<TimeDuration>): TimeDuration {
        let obj = Object.assign(new TimeDuration(), model);
        TimeDuration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TimeDuration>): TimeDuration {
        if (!model) return null;
        return TimeDuration.newInstance(<TimeDuration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TimeDuration) {
        if (!obj) return;

        models.TimeDuration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TimeDuration): boolean {
        Object.setPrototypeOf(obj, TimeDuration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.amount === undefined) {
            this.amount = 0;
        }
    }

    amount: number;

    unit: models.ChronoUnit;

}
